import useCompanyId from '@/hooks/useCompanyId';
import { logoutAndRedirect } from '@/redux/actions/userActions';
import { useAuth, useSignIn, useSignUp } from '@clerk/clerk-react';

const useLogoutAndRedirect = () => {
  const { setActive: setSignInActive } = useSignIn();
  const { setActive: setSignUpActive } = useSignUp();
  const { signOut, sessionId } = useAuth();
  const { setSessionCompanyId } = useCompanyId();

  return async () => {
    await Promise.all([
      //
      signOut({ sessionId }),
      setSignInActive({ session: null }),
      setSignUpActive({ session: null })
    ]);
    setSessionCompanyId(null);
    logoutAndRedirect();
  };
};

export default useLogoutAndRedirect;
